import { Component, inject, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PasswordConfirmValidator } from '../../../../shared/validators/password-conf.validator';
import { PasswordValidator } from '../../../../shared/validators/password.validator';
import { AuthService } from '../../../../services/auth/auth.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { SharedService } from '../../../../services/shared/shared.service';

@Component({
  selector: 'ag-changepassword-dialog',
  templateUrl: './changepassdialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChangePasswordDialogComponent implements OnInit {
  private _fb = inject(UntypedFormBuilder);
  private _authService = inject(AuthService);
  private _sharedService = inject(SharedService);

  passwordForm: UntypedFormGroup;
  submitting: boolean;

  constructor(
    private _dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.passwordForm = this._fb.group({
      password: ['', [Validators.required, PasswordValidator(this.data.isPasswordNumeric)]],
      passwordConfirm: ['', [PasswordConfirmValidator('password')]],
    });
  }

  changePassword() {
    this.submitting = true;
    this.passwordForm.markAllAsTouched();

    if (this.passwordForm.invalid) {
      this.submitting = false;
      return;
    }

    this._authService
      .updatePassword({ password: this.passwordControl.value })
      .pipe(finalize(() => (this.submitting = false)))
      .subscribe(
        () => {
          this._dialogRef.close(true);
        },
        (error: unknown) => {
          this._sharedService.openSnackBar('Error updating password');
          console.error(error);
        },
      );
  }

  get passwordControl() {
    return this.passwordForm.get('password');
  }

  get passwordConfirmControl() {
    return this.passwordForm.get('passwordConfirm');
  }
}
